module.exports = __webpack_public_path__ + "img/opiskelukuva.e4011b81.webp";